import {FormElementExposeInterface} from "~/cabinet/vue/interface/form/elements/useFormElement";

export interface CaptchaExposeInterface extends FormElementExposeInterface {
    refreshCaptcha: () => void
}

export const REFRESH_CAPTCHA_EVENT_NAME = "refreshCaptcha";